module.exports = __webpack_public_path__ + "static/img/3.0f4e4077.png";